import React from 'react';

import { t } from 'utils';

const Title = () => {
  return <h1 className='title'>{t.staticAsString('supportTaskManager.list.header')}</h1>;
};

export { Title };
